import { en } from './en';
import { ja } from './ja';
import { zhCN } from './zh-CN';
import { zhTW } from './zh-TW';
import { ko } from './ko';

export const resources = {
  en: en,
  ja: ja,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  ko: ko,
} as const;